import moment from "moment"
import { useSelector } from "react-redux"
import socketIoClient, { io } from "socket.io-client"
import { appConfig } from "../Environments/config"
import { isSocketConnected, pushActiveClient, pushSingleMessage, removeInActiveClient, setCurrentRoomInRedux, setMessages, setPageLoader } from "../Redux/Features"
import { utility } from "../Utility"

const socket = socketIoClient(appConfig.socketURL)
const user = JSON.parse(localStorage.getItem("admin"))

// const socket = io(appConfig.socketURL, {
//     transports: ['websocket', 'polling'],
//     reconnectionAttempts: 5,
//     reconnectionDelay: 2000,
//   });
const socketConnection = () => {
    utility.dispatch(setPageLoader({ page: "socket", flag: true }))
    socket.on('connect', async () => {
        console.log("Connected to Socket Server")
        utility.dispatch(isSocketConnected(true))
        utility.dispatch(setPageLoader({ page: "socket", flag: false }))
    })
    utility.dispatch(setPageLoader({ page: "socket", flag: false }))
}

socket.on("error", (error) => {
    console.error("Socket error:", error);
});

const joinRoom = (room_id) => {
    socket.emit("join_room", { room_id, by: "admin" })
}

const sendMessageSocket = (message, setMessage, room_id,messageId   ) => {
    socket.emit("admin-event[message:send]", {
        identity: "admin",
        message,
        room_id,
        admin_name:user?.name,
        messageId
        
    })
    utility.dispatch(pushSingleMessage({
        message: message,
        sender: "admin",
        timestamp: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")
    }))
    setMessage(null)
}

socket.on("admin-listner[message:receive]", (response) => {
    utility?.dispatch(pushSingleMessage(response))
})


const onLeaveRoom = (id, setCurrentRoom) => {
    socket.emit("leave_room", { room_id: id, by: "admin" })
    setCurrentRoom(null)
    utility.dispatch(setCurrentRoomInRedux(null))
}

socket.on("client-event[join-room]", (response) => {
    utility.dispatch(pushActiveClient(response?.room))
})

socket.on("client-event[leave-room]", (response) => {
    utility.dispatch(removeInActiveClient(response?.room))
})

export {
    joinRoom, sendMessageSocket, socketConnection, onLeaveRoom
}